import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import LockIcon from '@mui/icons-material/Lock';
import { FilterVal } from 'src/interfaces/iproptypes';

interface FilterButtonMenuProps {
  filterName: string ;
  MenuItemsComponent: (handleCloseMenu: () => void) => JSX.Element;
  buttonStyles: object;
  menuPaperProps: object;
  menuItemStyle: React.CSSProperties;
  setFilterVal: (filterVal: FilterVal) => void;
  filterVal: FilterVal;
  isMobileView: boolean;
  priceTiers?: any;
  currency: string;
  filterCount: number;
  showFilterComingSoonAlert: boolean | 'open';
  isUserAllowed: boolean;
}

const FilterButtonMenu: React.FC<FilterButtonMenuProps> = ({
  filterName,
  MenuItemsComponent,
  buttonStyles,
  menuPaperProps,
  menuItemStyle,
  setFilterVal,
  filterVal,
  priceTiers,
  isMobileView,
  currency,
  filterCount,
  showFilterComingSoonAlert,
  isUserAllowed,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(prev => prev ? null : event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        aria-controls={`${filterName.toLowerCase()}-menu`}
        aria-haspopup="true"
        onClick={handleOpenMenu}
        sx={buttonStyles}
        size="small"
        endIcon={<KeyboardArrowDownRoundedIcon />}
      >
        {!isUserAllowed && <LockIcon sx={{ fontSize: '14px', mr: '2px' }} />} {filterName}
        {filterCount > 0 && (
          <Typography component="span" sx={{ ml: 0.5, fontWeight: 'inherit', fontSize: 'inherit' }}>
            ({filterCount})
          </Typography>
        )}
      </Button>
      <Menu
        id={`${filterName.toLowerCase()}-menu`}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        PaperProps={menuPaperProps}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}        
      >
        {MenuItemsComponent(handleCloseMenu)}
      </Menu>
    </Box>
  );
};

export default FilterButtonMenu;
